import Modal from "components/layout/modal";
import { FunctionComponent } from "react";
import EditLocaleModalForm from "./edit-locale-modal-form";
import { useListUser } from "stores/hooks/list-user";
import { Locale } from "models/locale";
import { adminDoPatchListUser } from "services/admin/list-user";
import { useList } from "stores/hooks/list";
import { fetchAdminListUser } from "stores/actions/list-user";

interface EditLocaleModalProps {
  onClose: () => Promise<void>;
}

const EditLocaleModal: FunctionComponent<EditLocaleModalProps> = ({
  onClose,
}) => {
  const list = useList();
  const listUser = useListUser();

  if (!list || !listUser) {
    return null;
  }

  const onSubmit = async (locale: Locale) => {
    // update
    await adminDoPatchListUser(list, listUser.uuid, { locale });

    // fetch state
    fetchAdminListUser(list, listUser.uuid);

    // close modal
    onClose();
  };

  return (
    <Modal title="Vaihda kieltä">
      <EditLocaleModalForm
        onSubmit={onSubmit}
        onClose={onClose}
        user={listUser}
      />
    </Modal>
  );
};

export default EditLocaleModal;
